import axios from "axios";
import { type GameResponse } from "../types";

export const getGames = async (uri: string): Promise<GameResponse> => {
    return await axios.get(uri)
    .then(response => response.data)
    .catch(() => window.location.href = '/404')
}